import IsNullOrUndefined from "./ObjectUtils";
import {FeatureType} from "../model/constants";

export const currencyFormatter = new Intl.NumberFormat('de-DE', { // es-ES
    style: 'currency',
    currency: 'EUR',
});

export const getFeaturePriceText = (feature, currentUnit) => {
    if (feature.look_type === FeatureType.Improvement) {
      if (feature.isPriceDefined === false){
        return '[Precio por definir]';
      }
      else if (feature.pricePerUnit !== false) {
        if (IsNullOrUndefined(currentUnit)) {
          return '[Precio según vivienda]';
        } else {
          return currencyFormatter.format(parseFloat(feature.price));
        }

      } else {
        return currencyFormatter.format(parseFloat(feature.price));
      }
    }
    else if (feature.look_type === FeatureType.Default) {
        return '';
    }
    else {
        return currencyFormatter.format(parseFloat(feature.price));
    }
};
export const getPriceText = (price) => {
    return currencyFormatter.format(parseFloat(price));
};
/* export const getPriceText = (price, showPrices) => {
    if (showPrices) {
        return (IsNullOrUndefined(price) || price === '0') ? currencyFormatter.format(0) : currencyFormatter.format(parseFloat(price));
    }

    return (price === null || price === '0') ? 'sin coste' : 'con coste';
}; */
